var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticClass:"text-base font-semibold mb-2"},[_vm._v("Customer details:")]),_c('CustomerDetailsFieldGroup',{attrs:{"userData":_vm.userData,"setCustomerCode":_vm.setCustomerCode,"handlePhoneBlur":_vm.onlyNumberAndSpaceBlur}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }